<div class="p-3">
   <div *ngIf="selectedNode?.type === NodeType.WaitDaysForDueDate && selectedNode">
      <p-messages severity="info" [closable]="true">
         <ng-template pTemplate>
            <div class="p-message flex flex-row gap-2">
               <span class="pi pi-info-circle p-1"></span>
               <span
                  [innerHTML]="
                     'DATA.MODULES.CAMPAINGS.WORKFLOWS.WAIT.INFO_WAIT_DAYS_FOR_DUE_DATE'
                        | translate
                           : {
                                partDay: getPartDay(),
                                waitDays: getWaitDays(),
                                beforeOrAfter: selectedNode.config['antesODespues']
                                   ? (selectedNode && selectedNode.config['antesODespues'] | translate)
                                   : '-'
                             }
                  "
               ></span>
            </div>
         </ng-template>
      </p-messages>
   </div>

   <div *ngIf="selectedNode?.type === NodeType.WaitDays && selectedNode">
      <div class="-mt-3">
         <p-checkbox
            (click)="manageRetryRange()"
            binary="true"
            [(ngModel)]="showRetryRange"
            label="¿Quieres personalizar la franja horaria de envío?"
         ></p-checkbox>
      </div>

      <div class="my-3">
         <p-button
            label="Ver configuración regional"
            [icon]="!accordionVisible ? 'pi pi-clock' : 'pi pi-chevron-up'"
            (click)="toggleAccordion()"
            severity="secondary"
            size="small"
            styleClass="w-full"
            class="w-full"
         ></p-button>
      </div>

      <div *ngIf="accordionVisible">
         <p-accordion [multiple]="true" [styleClass]="'flex flex-column gap-1'">
            <p-accordionTab *ngFor="let group of groupedCollectors">
               <ng-template pTemplate="header">
                  <div pTooltip="{{ getCollectorNames(group) }}" tooltipPosition="top" class="truncate-header">
                     {{ getCollectorNamesShort(group) }}
                  </div>
               </ng-template>

               <div class="flex flex-column py-2">
                  <div class="flex flex-row gap-1">
                     <div class="text-800 font-semibold">Timezone:</div>
                     <div class="text-500">{{ group.timezone }}</div>
                  </div>

                  <p-divider></p-divider>

                  <div class="flex flex-column gap-2 mt-2">
                     <div class="flex flex-row gap-1" *ngFor="let entry of getTimetableEntries(group.timetable)">
                        <div class="text-800 font-semibold">{{ entry.label }}:</div>
                        <div class="text-500">{{ entry.start }} - {{ entry.finish }}</div>
                     </div>
                  </div>
               </div>
            </p-accordionTab>
         </p-accordion>
      </div>

      <div
         *ngIf="showRetryRange && interval != null"
         class="flex items-center gap-2 p-3 mt-2 align-items-center border-round surface-0 surface-hover cursor-pointer"
      >
         <p-calendar
            [(ngModel)]="interval!.start"
            (ngModelChange)="onRetryRangeTimeChange('start', $event)"
            [timeOnly]="true"
            [hourFormat]="'24'"
            [showIcon]="true"
            iconDisplay="input"
            inputStyleClass="p-inputtext"
         />
         <span>-</span>
         <p-calendar
            [(ngModel)]="interval!.finish"
            (ngModelChange)="onRetryRangeTimeChange('finish', $event)"
            [timeOnly]="true"
            [hourFormat]="'24'"
            [showIcon]="true"
            iconDisplay="input"
            inputStyleClass="p-inputtext"
         />
      </div>

      <div class="text-red-500 text-sm pl-5" *ngIf="rangeErrors.invalidOrder">
         La hora inicial debe ser menor que la final.
      </div>
      <div class="text-red-500 text-sm pl-5" *ngIf="rangeErrors.overlaps">
         Esta franja se superpone con otra franja seleccionada.
      </div>

      <p-messages severity="info" [closable]="true">
         <ng-template pTemplate>
            <div class="p-message flex flex-row gap-2">
               <span class="pi pi-info-circle p-1"></span>
               <span
                  [innerHTML]="
                     'DATA.MODULES.CAMPAINGS.WORKFLOWS.WAIT.INFO_WAIT_DAYS'
                        | translate: { partDay: getPartDay(), waitDays: getWaitDays() }
                  "
               ></span>
            </div>
         </ng-template>
      </p-messages>
   </div>

   <div *ngIf="selectedNode?.type === NodeType.WaitDayOfWeek && selectedNode">
      <p-messages severity="info" [closable]="true">
         <ng-template pTemplate>
            <div class="p-message flex flex-row gap-2">
               <span class="pi pi-info-circle p-1"></span>
               <span
                  [innerHTML]="
                     'DATA.MODULES.CAMPAINGS.WORKFLOWS.WAIT.INFO_WAIT_DAY_OF_WEEK'
                        | translate: { partDay: getPartDay(), dayOfWeek: getDayOfWeek() }
                  "
               ></span>
            </div>
         </ng-template>
      </p-messages>
   </div>

   <div *ngIf="selectedNode?.type === NodeType.WaitDayOfMonth && selectedNode">
      <p-messages severity="info" [closable]="true">
         <ng-template pTemplate>
            <div class="p-message flex flex-row gap-2">
               <span class="pi pi-info-circle p-1"></span>
               <span
                  [innerHTML]="
                     'DATA.MODULES.CAMPAINGS.WORKFLOWS.WAIT.INFO_WAIT_DAY_OF_MONTH'
                        | translate: { partDay: getPartDay(), dayOfMonth: getDayOfMonth() }
                  "
               ></span>
            </div>
         </ng-template>
      </p-messages>
   </div>
</div>
